import SelfDiagnosticTest from './StaticContents/SelfDiagnosticTest';
import { testRenderer } from './index';
import GuideRobotDescription from './StaticContents/GuideRobotDescription';
import MedicineDeliveryRobotDescription from './StaticContents/MedicineDeliveryRobotDescription';
import SpecimensDeliveryRobotDescription from './StaticContents/SpecimensDeliveryRobotDescription';
import DocumentDeliveryRobotDescription from './StaticContents/DocumentDeliveryRobotDescription';
import TestResult from './StaticContents/TestResult';
import { getAnswerNum } from './TestPage/QuestionFooter';

export const TEST_KEY = {
    SELF_ASSESSMENT: 'selfAssessment',
    READINESS: 'readiness',
    GUIDE_BOT: 'guideBot',
    MEDI_BOT: 'mediBot',
    SPECI_BOT: 'speciBot',
    DOCU_BOT: 'docuBot',
    TEST_RESULT: 'testResult',
};

export const SCORE_KEY = {
    readiness: 'readinessScore',
    guideBot: 'guideRobotScore',
    mediBot: 'medDeliveryRobotScore',
    speciBot: 'specimenDeliveryRobotScore',
    docuBot: 'docDeliveryRobotScore',
};

export const ANSWER_KEY = {
    readiness: 'COMMON',
    guideBot: 'GUIDE_ROBOT',
    mediBot: 'MED_DELIVERY_ROBOT',
    speciBot: 'SPECIMEN_DELIVERY_ROBOT',
    docuBot: 'DOC_DELIVERY_ROBOT',
};

export const orderedTest = [
    {
        key: TEST_KEY.SELF_ASSESSMENT,
        title: '자가 진단 테스트',
        subTitle: 'Guide',
        progressStatus: false,
        questionNum: 0,
        totalScore: [],
        selectedAnswers: [],
        conversionFactor: null,
    },
    {
        key: TEST_KEY.READINESS,
        title: '공통 문항',
        subTitle: null,
        progressStatus: true,
        questionNum: 0,
        totalScore: [],
        selectedAnswers: [],
        conversionFactor: 3.333,
    },
    {
        key: TEST_KEY.GUIDE_BOT,
        title: '안내 로봇',
        subTitle: null,
        progressStatus: true,
        questionNum: 0,
        totalScore: [],
        selectedAnswers: [],
        conversionFactor: 4,
    },
    {
        key: TEST_KEY.MEDI_BOT,
        title: '약제 배송 로봇',
        subTitle: null,
        progressStatus: true,
        questionNum: 0,
        totalScore: [],
        selectedAnswers: [],
        conversionFactor: 1.667,
    },
    {
        key: TEST_KEY.SPECI_BOT,
        title: '검체 배송 로봇',
        subTitle: null,
        progressStatus: true,
        questionNum: 0,
        totalScore: [],
        selectedAnswers: [],
        conversionFactor: 2,
    },
    {
        key: TEST_KEY.DOCU_BOT,
        title: '문서 배송 로봇',
        subTitle: null,
        progressStatus: true,
        questionNum: 0,
        totalScore: [],
        selectedAnswers: [],
        conversionFactor: 2,
    },
    {
        key: TEST_KEY.TEST_RESULT,
        title: '테스트 결과',
        subTitle: 'Result',
        progressStatus: false,
        questionNum: 0,
        totalScore: [],
        selectedAnswers: [],
        conversionFactor: null,
    },
];

export const getNextTest = (currentTestKey, testList) => {
    const newTestList = testList ?? orderedTest;
    const currentTestIndex = newTestList.findIndex(testInfo => testInfo.key === currentTestKey);
    return newTestList[currentTestIndex + 1];
};

export const getPrevTest = (currentTestKey, testList) => {
    const newTestList = testList ?? orderedTest;
    const currentTestIndex = newTestList.findIndex(testInfo => testInfo.key === currentTestKey);
    return newTestList[currentTestIndex - 1];
};

export const testToStep = {
    [TEST_KEY.SELF_ASSESSMENT]: [
        {
            key: 'Q01',
            questionText: null,
            answers: [],
            contents: SelfDiagnosticTest,
        },
    ],
    [TEST_KEY.READINESS]: [
        {
            key: 'Q01',
            questionText: '서비스 로봇의 도입 목적은 무엇인가요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '환자 및 방문객 서비스 지원', score: 0 },
                { key: 'A02', text: '업무 효율성 및 인력 보조', score: 0 },
                { key: 'A03', text: '병원 첨단 이미지 구축', score: 0 },
            ],
        },
        {
            key: 'Q02',
            questionText: '서비스 로봇 도입을 주도하는 담당 부서의 권한도는 어떠한가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '주도부서없음', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q03',
            questionText: '로봇 도입 업무를 담당하는 실무진의 협조도는 어떤가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '협의되지 않음', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q04',
            questionText: '로봇 도입 초기 투여 가능한 예산의 범위는 어느정도인가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '5000만원 미만', score: 1 },
                { key: 'A02', text: `5000만원 이상<br>1억원 미만`, score: 2 },
                { key: 'A03', text: `1억원 이상<br>3억원 미만`, score: 3 },
                { key: 'A04', text: `3억원 이상<br>5억원 미만`, score: 4 },
                { key: 'A05', text: '5억원 이상', score: 5 },
            ],
        },
        {
            key: 'Q05',
            questionText: `유지 보수 및 사용료 등 매년 소요되는 예산의<br>확보 가능 범위는 어느정도인가요?`,
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '500만원 미만', score: 1 },
                { key: 'A02', text: `500만원 이상<br>1,000만원 미만`, score: 2 },
                { key: 'A03', text: `1,000만원 이상<br>3,000만원 미만`, score: 3 },
                { key: 'A04', text: `3,000만원 이상<br>5,000만원 미만`, score: 4 },
                { key: 'A05', text: '5,000만원 이상', score: 5 },
            ],
        },
        {
            key: 'Q06',
            questionText: `로봇 이외의 병원 서비스 관련 신기술 도입 경험의<br>정착도는 어떠한가요?`,
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '도입 경험 없음', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
            handleNextQuestion: selected => {
                const { key, score } = selected[0];
                const currentTest = getCurrTest();
                const { questionNum, totalScore, selectedAnswers } = currentTest;
                let nextQuestionNum = questionNum + 1;
                const nextTotalScore = [...totalScore, Number(score)];
                const nextSelectedAnswers = [...selectedAnswers, getAnswerNum(currentTest, key)];

                if (key === 'A01') {
                    nextQuestionNum += 1;
                    nextTotalScore.push(null);
                    nextSelectedAnswers.push(null);
                }

                setCurrTest({
                    ...currentTest,
                    questionNum: nextQuestionNum,
                    totalScore: nextTotalScore,
                    selectedAnswers: nextSelectedAnswers,
                });

                testRenderer(getCurrTest());
            },
        },
        {
            key: 'Q07',
            questionText: `로봇 활용 경험이 있다면, 만족도는 어떠한가요?<br>(재활, 수술로봇 제외)`,
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: `로봇 활용경험<br>없음`, score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
            handleNextQuestion: selected => {
                const { score, key } = selected[0];
                const currentTest = getCurrTest();
                const { questionNum, totalScore, selectedAnswers } = currentTest;

                setCurrTest({
                    ...currentTest,
                    questionNum: questionNum + 2,
                    totalScore: [...totalScore, Number(score), null],
                    selectedAnswers: [...selectedAnswers, getAnswerNum(currentTest, key), null],
                });

                testRenderer(getCurrTest());
            },
        },
        {
            key: 'Q08',
            questionText: '로봇 활용에 대한 어느정도 기대감을 갖고있나요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '매우 낮음', score: 0 },
                { key: 'A02', text: '낮음', score: 0 },
                { key: 'A03', text: '보통', score: 0 },
                { key: 'A04', text: '높음', score: 0 },
                { key: 'A05', text: '매우 높음', score: 0 },
            ],
        },
        {
            key: 'Q09',
            questionText: `도입 희망 로봇은 어떤 종류의 로봇인가요? (복수 선택 가능)<br>선택하지 않은 로봇의 질문은 건너뜁니다.`,
            multipleSelection: true,
            answersType: 'vertical',
            answers: [
                { key: 'A01', value: TEST_KEY.GUIDE_BOT, text: '안내 로봇', score: 0 },
                { key: 'A02', value: TEST_KEY.MEDI_BOT, text: '약제 배송 로봇', score: 0 },
                { key: 'A03', value: TEST_KEY.SPECI_BOT, text: '검체 배송 로봇', score: 0 },
                { key: 'A04', value: TEST_KEY.DOCU_BOT, text: '문서 배송 로봇', score: 0 },
            ],
            handleNextQuestion: selected => {
                const currentTest = getCurrTest();
                const { totalScore, selectedAnswers } = currentTest;
                setCurrTest({
                    ...currentTest,
                    totalScore: [...totalScore, 0],
                    selectedAnswers: [
                        ...selectedAnswers,
                        selected.map(answer => getAnswerNum(currentTest, answer.key)),
                    ],
                });
                const newCurrentTest = getCurrTest();
                setTestList([
                    newCurrentTest,
                    ...orderedTest.filter(testInfo => selected.map(({ value }) => value).includes(testInfo.key)),
                ]);
                const nextTest = getNextTest(newCurrentTest.key, getTestList());
                if (nextTest?.key) {
                    setCurrTest({ ...nextTest });
                }
                testRenderer(getCurrTest());
            },
        },
    ],
    [TEST_KEY.GUIDE_BOT]: [
        {
            key: 'Q01',
            questionText: null,
            answers: [],
            contents: GuideRobotDescription,
        },
        {
            key: 'Q02',
            questionText: '1일 내방객 동행 안내 횟수는 몇 회인가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '5회 미만', score: 1 },
                { key: 'A03', text: `5회 이상<br>10회 미만`, score: 2 },
                { key: 'A04', text: `10회 이상<br>30회 미만`, score: 3 },
                { key: 'A05', text: `30회 이상<br>50회 미만`, score: 4 },
                { key: 'A06', text: '50회 이상', score: 5 },
            ],
        },
        {
            key: 'Q03',
            questionText: '안내데스크 요원의 로봇 활용 의지는 어떤가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q04',
            questionText: '안내 동선에 여닫이 문이나 통제되는 출입구가 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '여닫이 문 있음(통제되는 자동문 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '여닫이 문은 없지만, 통제되는 자동문이 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q05',
            questionText: `동행 안내 시 로봇의 층간 이동을 위해 활용할 수 있는<br>엘리베이터가 있나요?`,
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '충분한 엘리베이터가 마련되어 있음', score: 5 },
                { key: 'A02', text: '엘리베이터는 있으나, 충분하지 않음', score: 3 },
                { key: 'A03', text: '없음', score: 1 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q06',
            questionText: '수평 이동 시 로봇 통행이 어려운 계단이나 경사로가 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '계단이 있음 (경사로 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '계단은 없지만, 경사로가 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
    ],
    [TEST_KEY.MEDI_BOT]: [
        {
            key: 'Q01',
            questionText: null,
            answers: [],
            contents: MedicineDeliveryRobotDescription,
        },
        {
            key: 'Q02',
            questionText: '로봇을 사용하려고 하는 배송 형태는 어떤 것인가요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '정규 배송', score: 0 },
                { key: 'A02', text: '비정규 배송', score: 0 },
                { key: 'A03', text: '정규 배송, 비정규 배송 모두', score: 0 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q03',
            questionText: '약제 배송이 필요한 부서는 몇 군데로 예상되나요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '2개 이하', score: 1 },
                { key: 'A03', text: `3개 이상<br>6개 미만`, score: 2 },
                { key: 'A04', text: `6개 이상<br>10개 미만`, score: 3 },
                { key: 'A05', text: `10개 이상<br>20개 미만`, score: 4 },
                { key: 'A06', text: '20개 이상', score: 5 },
            ],
        },
        {
            key: 'Q04',
            questionText: '로봇을 활용한 하루 배송 횟수는 몇 회로 예상되나요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '4회 이하', score: 1 },
                { key: 'A03', text: `5회 이상<br>10회 미만`, score: 2 },
                { key: 'A04', text: `10회 이상<br>20회 미만`, score: 3 },
                { key: 'A05', text: `20회 이상<br>50회 미만`, score: 4 },
                { key: 'A06', text: '50회 이상', score: 5 },
            ],
        },
        {
            key: 'Q05',
            questionText: '1회당 평균 배송할 약제의 수는 몇 개로 예상되나요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '5개 미만', score: 1 },
                { key: 'A03', text: `5개 이상<br>10개 미만`, score: 2 },
                { key: 'A04', text: `10개 이상<br>20개 미만`, score: 3 },
                { key: 'A05', text: `20개 이상<br>30개 미만`, score: 4 },
                { key: 'A06', text: '30개 이상', score: 5 },
            ],
        },
        {
            key: 'Q06',
            questionText: '약제팀의 로봇 활용 의지는 어떠한가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q07',
            questionText: '약제팀의 업무 변경에 대한 설명과 이해 및 협의가 이루어졌나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '설명하지 않았음', score: 0 },
                { key: 'A02', text: '설명하였으나 협의되지 않음', score: 1 },
                { key: 'A03', text: '설명하였고, 협의 중', score: 3 },
                { key: 'A04', text: '설명 및 협의 완료', score: 5 },
            ],
        },
        {
            key: 'Q08',
            questionText: '약제 수령 부서의 로봇 활용 의지는 어떠한가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q09',
            questionText: `약제 수령 부서의 업무 변경에 대한 설명과<br>이해 및 협의가 이루어졌나요?`,
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '설명하지 않았음', score: 0 },
                { key: 'A02', text: '설명하였으나 협의되지 않음', score: 1 },
                { key: 'A03', text: '설명하였고, 협의 중', score: 3 },
                { key: 'A04', text: '설명 및 협의 완료', score: 5 },
            ],
        },
        {
            key: 'Q10',
            questionText: '약제팀 근처에 로봇 대기 공간이 충분히 확보되어 있나요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '전혀 없음', score: 1 },
                { key: 'A03', text: '충분하지 않음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '충분함', score: 4 },
                { key: 'A06', text: '매우 충분함', score: 5 },
            ],
        },
        {
            key: 'Q11',
            questionText: '약제 수령지에 로봇 대기 공간이 충분히 확보되어 있나요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '전혀 없음', score: 1 },
                { key: 'A03', text: '충분하지 않음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '충분함', score: 4 },
                { key: 'A06', text: '매우 충분함', score: 5 },
            ],
        },
        {
            key: 'Q12',
            questionText: '이동 동선에 여닫이문이나 통제된 출입구가 포함되어 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '여닫이 문 있음(통제되는 자동문 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '여닫이 문은 없지만, 통제되는 자동문이 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q13',
            questionText: '층간 이동 시 로봇이 사용할 엘리베이터가 마련되어 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '충분한 엘리베이터가 마련되어 있음', score: 5 },
                { key: 'A02', text: '엘리베이터는 있으나, 충분하지 않음', score: 3 },
                { key: 'A03', text: '없음', score: 1 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q14',
            questionText: '수평 이동 시 로봇의 통행을 방해할 수 있는 계단이나 경사로가 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '계단이 있음 (경사로 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '계단은 없지만, 경사로가 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
    ],
    [TEST_KEY.SPECI_BOT]: [
        {
            key: 'Q01',
            questionText: null,
            answers: [],
            contents: SpecimensDeliveryRobotDescription,
        },
        {
            key: 'Q02',
            questionText: '로봇 사용이 예상되는 1일 평균 검체 배송은 몇 회인가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '5회 미만', score: 1 },
                { key: 'A03', text: `5회 이상<br>10회 미만`, score: 2 },
                { key: 'A04', text: `10회 이상<br>20회 미만`, score: 3 },
                { key: 'A05', text: `20회 이상<br>50회 미만`, score: 4 },
                { key: 'A06', text: '50회 이상', score: 5 },
            ],
        },
        {
            key: 'Q03',
            questionText: '검체 발송지(진료과 혹은 검사실)의 로봇 활용 의지는 어떠한가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q04',
            questionText: `검체 발송지(진료과 혹은 검사실)의 업무 변경에 대한 설명과<br>이해/협의가 이루어졌나요?`,
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '설명하지 않았음', score: 0 },
                { key: 'A02', text: '설명하였으나 협의되지 않음', score: 1 },
                { key: 'A03', text: '설명하였고, 협의 중', score: 3 },
                { key: 'A04', text: '설명 및 협의 완료', score: 5 },
            ],
        },
        {
            key: 'Q05',
            questionText: '수령지(병리과/진단의학과 등)의 로봇 활용 의지는 어떤가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q06',
            questionText: `수령지(병리과/진단의학과 등)의 업무 변경에 대한 설명과<br>이해/협의가 이루어졌나요?`,
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '설명하지 않았음', score: 0 },
                { key: 'A02', text: '설명하였으나 협의되지 않음', score: 1 },
                { key: 'A03', text: '설명하였고, 협의 중', score: 3 },
                { key: 'A04', text: '설명 및 협의 완료', score: 5 },
            ],
        },
        {
            key: 'Q07',
            questionText: '검체 발송지(진료과 혹은 검사실 등)에 로봇의 대기 공간이 충분한가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '전혀 없음', score: 1 },
                { key: 'A03', text: '충분하지 않음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '충분함', score: 4 },
                { key: 'A06', text: '매우 충분함', score: 5 },
            ],
        },
        {
            key: 'Q08',
            questionText: '검체 수령지에 로봇 대기 공간이 충분히 확보되어 있나요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q09',
            questionText: '이동 동선에 여닫이문이나 통제된 출입구가 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '여닫이 문 있음(통제되는 자동문 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '여닫이 문은 없지만, 통제되는 자동문이 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q10',
            questionText: '층간 이동 시 로봇이 사용할 엘리베이터가 마련되어 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '충분한 엘리베이터가 마련되어 있음', score: 5 },
                { key: 'A02', text: '엘리베이터는 있으나, 충분하지 않음', score: 3 },
                { key: 'A03', text: '없음', score: 1 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q11',
            questionText: '수평 이동 시 로봇의 통행을 방해할 수 있는 계단이나 경사로가 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '계단이 있음 (경사로 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '계단은 없지만, 경사로가 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
    ],
    [TEST_KEY.DOCU_BOT]: [
        {
            key: 'Q01',
            questionText: null,
            answers: [],
            contents: DocumentDeliveryRobotDescription,
        },
        {
            key: 'Q02',
            questionText: '로봇을 활용한 문서 발송이 필요한 부서는 몇 군데인가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '2개 이하', score: 1 },
                { key: 'A03', text: `3개 이상<br>5개 미만`, score: 2 },
                { key: 'A04', text: `5개 이상<br>10개 미만`, score: 3 },
                { key: 'A05', text: `10개 이상<br>20개 미만`, score: 4 },
                { key: 'A06', text: '20개 이상', score: 5 },
            ],
        },
        {
            key: 'Q03',
            questionText: '문서 발송지의 로봇 활용 의지는 어떤가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q04',
            questionText: '문서 발송지의 업무 변경에 대한 설명과 이해 및 협의가 이루어졌나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '설명하지 않았음', score: 0 },
                { key: 'A02', text: '설명하였으나 협의되지 않음', score: 1 },
                { key: 'A03', text: '설명하였고, 협의 중', score: 3 },
                { key: 'A04', text: '설명 및 협의 완료', score: 5 },
            ],
        },
        {
            key: 'Q05',
            questionText: '문서 수령지의 로봇 활용 의지는 어떤가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '매우 낮음', score: 1 },
                { key: 'A03', text: '낮음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '높음', score: 4 },
                { key: 'A06', text: '매우 높음', score: 5 },
            ],
        },
        {
            key: 'Q06',
            questionText: `문서 수령지의 업무 변경에 대한 설명과<br>이해 및 협의가 이루어졌나요?`,
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '설명하지 않았음', score: 0 },
                { key: 'A02', text: '설명하였으나 협의되지 않음', score: 1 },
                { key: 'A03', text: '설명하였고, 협의 중', score: 3 },
                { key: 'A04', text: '설명 및 협의 완료', score: 5 },
            ],
        },
        {
            key: 'Q07',
            questionText: '각 발송지에 로봇 대기 공간이 충분한가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '전혀 없음', score: 1 },
                { key: 'A03', text: '충분하지 않음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '충분함', score: 4 },
                { key: 'A06', text: '매우 충분함', score: 5 },
            ],
        },
        {
            key: 'Q08',
            questionText: '수령지에 로봇 대기 공간이 충분한가요?',
            answersType: 'horizontal',
            answers: [
                { key: 'A01', text: '모름', score: 0 },
                { key: 'A02', text: '전혀 없음', score: 1 },
                { key: 'A03', text: '충분하지 않음', score: 2 },
                { key: 'A04', text: '보통', score: 3 },
                { key: 'A05', text: '충분함', score: 4 },
                { key: 'A06', text: '매우 충분함', score: 5 },
            ],
        },
        {
            key: 'Q09',
            questionText: '이동 동선에 여닫이문이나 통제된 출입구가 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '여닫이 문 있음(통제되는 자동문 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '여닫이 문은 없지만, 통제되는 자동문이 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q10',
            questionText: '층간 이동 시 로봇이 사용할 엘리베이터가 마련되어 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '충분한 엘리베이터가 마련되어 있음', score: 5 },
                { key: 'A02', text: '엘리베이터는 있으나, 충분하지 않음', score: 3 },
                { key: 'A03', text: '없음', score: 1 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
        {
            key: 'Q11',
            questionText: '수평 이동 시 로봇의 통행을 방해할 수 있는 계단이나 경사로가 있나요?',
            answersType: 'vertical',
            answers: [
                { key: 'A01', text: '계단이 있음 (경사로 유,무 상관없이)', score: 1 },
                { key: 'A02', text: '계단은 없지만, 경사로가 있음', score: 3 },
                { key: 'A03', text: '둘 다 없음', score: 5 },
                { key: 'A04', text: '모름', score: 0 },
            ],
        },
    ],
    [TEST_KEY.TEST_RESULT]: [
        {
            key: 'Q01',
            questionText: null,
            answers: [],
            contents: TestResult,
        },
    ],
};

export const getTestResultClass = totalScore => {
    if (totalScore < 20) {
        return 'red';
    }
    if (totalScore <= 40) {
        return 'orange';
    }
    if (totalScore < 80) {
        return 'yellow';
    }
    return 'blue';
};

export const resultClassToDescription = {
    red: '로봇 도입이 어려울 것 같습니다.',
    orange: '도입에 많은 준비가 필요합니다.',
    yellow: `열심히 노력하면<br>로봇 도입이 가능!`,
    blue: `로봇 도입 가능!<br>구체적으로 알아봅시다.`,
};

export const getCurrTest = () => {
    return window.currentTest;
};

export const setCurrTest = testInfo => {
    window.currentTest = testInfo;
};

export const getTestList = () => {
    return window.testList;
};

export const setTestList = testList => {
    window.testList = testList;
};

export const getSubmissionNum = () => {
    return window.submissionNum;
};

export const setSubmissionNum = subNum => {
    window.submissionNum = subNum;
};
